/**
 * Sanitize OrgRanksColors values for HTML data-* attributes (CSP: no inline style).
 * Only allows #hex, #shorthex, or rgb()/rgba() with numeric components.
 * @param {unknown} raw
 * @returns {string|null}
 */
export function sanitizeColorForDataAttr(raw) {
  if (raw == null || typeof raw !== "string") return null;
  const s = raw.trim();
  if (!s) return null;
  if (/^#[0-9a-fA-F]{6}$/.test(s)) return s;
  if (/^#[0-9a-fA-F]{3}$/.test(s)) {
    const [a, b, c] = s.slice(1).split("");
    return `#${a}${a}${b}${b}${c}${c}`;
  }
  const m = s.match(
    /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([\d.]+)\s*\)$/i
  );
  if (m) {
    const r = Number(m[1]);
    const g = Number(m[2]);
    const b = Number(m[3]);
    const a = Math.min(1, Math.max(0, Number(m[4])));
    if (r > 255 || g > 255 || b > 255 || !Number.isFinite(a)) return null;
    return `rgba(${r},${g},${b},${a})`;
  }
  const m2 = s.match(/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i);
  if (m2) {
    const r = Number(m2[1]);
    const g = Number(m2[2]);
    const b = Number(m2[3]);
    if (r > 255 || g > 255 || b > 255) return null;
    return `rgb(${r},${g},${b})`;
  }
  return null;
}

/** data-chip-bg / data-chip-fg for rank-tinted chips; colors applied via rankChipCspStyles.js (CSP-safe). */
export function buildRankChipDataAttrs(rankColors) {
  const bg = sanitizeColorForDataAttr(rankColors?.chipColor);
  if (!bg) return {};
  const fg = sanitizeColorForDataAttr(rankColors?.text);
  const attrs = { "data-chip-bg": bg };
  if (fg) attrs["data-chip-fg"] = fg;
  return attrs;
}
